var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{staticClass:"textarea",class:!_vm.isValid ? 'is-danger': '',attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"blur":_vm.handleInput}}),_vm._v(" "),(!_vm.isValid)?_c('p',{staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }